export default __webpack_public_path__ + "media/images/config-c49aafcb0354fe3109e29db0e584c598.png";